import { Tab, Tabs, styled } from "@mui/material";
import React from "react";

export default function TabsList({ value, tabs, handleChange }) {
  return (
    <div>
      <TabContainer
        value={value}
        onChange={handleChange}
        aria-label="icon label tabs example"
        indicatorColor=""
      >
        {tabs?.map((tab, id) => (
          <Tab
            key={id}
            icon={tab?.icon}
            iconPosition={tab?.iconPosition}
            label={tab?.label}
          />
        ))}
      </TabContainer>
    </div>
  );
}

const TabContainer = styled(Tabs)(({ theme }) => ({
  alignItems: "center",
  height: "100%",
  "& .Mui-selected": {
    color: "#A7E57C !important",
    // background: "aqua",
  },
}));
